;(function(gardaseeContext) {
    "use strict";

    // privates
    var currentAmenityIds = [];
    var currentBoardingIds = [];

    // public
    window.initEnquiryForm = function() {
        var $form = $("form#enquiryform[data-v=2]");
        if (!$form.length) {
            return;
        }

        //$form.find('input:visible, select:visible, textarea:visible').first().focus().change(); // performs auto scroll to enquiryform on micropage :(

        initChildrenages($form);
        bindValidation($form);
        bindSubmit($form);

        $('#postModel_EnquiryData_Arrival').RangeDatepick({
            inputFrom: '#postModel_EnquiryData_Arrival',
            inputTo: '#postModel_EnquiryData_Departure',
            elementToFocusOnClose: '#postModel_EnquiryData_Nights',
            maxMonthsToShow: 2,
            lang: gardaseeContext.language
        });
    };


    $(document).ready(initEnquiryForm);


    function bindSubmit($form) {
        $form.submit(function (e) {
            e.preventDefault();

            $form.validate();
            if (!$form.valid()) {
                return;
            }

            $form.find('.loading').show();

            var data = $form.serializeObject();
            data.boardingIds = currentBoardingIds;
            data.amenityIds = currentAmenityIds;
            // rooms Array
            var rooms = [];
            rooms.push({
                adults: data.adults,
                children: data.children,
                childrenAges: data.ChildrenAges
            })

            // filter
            var filter = {};
            filter.boardingids = data.boardingIds;

            data = Object.assign(data, { rooms: rooms });
            data = Object.assign(data, { filter: filter });

            // EnquiryDto accepts only bools not strings
            data.privacy = data.privacy === "true" ? true : false
            data.newsletter = data.newsletter === "true" ? true : false


            data.companyIds = data.companyIds.split(",")

            $.ajax({
                cache: false,
                url: '/api/enquiry/saveenquiry',
                type: "POST",
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(data),
                success: function (callback) {
                    if (callback.success === true) {
                        var filter = getEnquiryFilter();
                        gardaseeContext.LoadEnquiryThanks(data.companyId, data.arrival, data.departure, filter); // <- this hides the loader!
                        trackGtm(data, callback);
                    } else {
                        $('#output').html(formatErrors(callback.validationErrors));
                        $('#output').show();
                        $form.find('.loading').hide();
                    }
                },
                error: function () {
                    $('#output').html("Error!");
                    $('#output').show();
                    $form.find('.loading').hide();
                }
            });
        });
    }


    function bindValidation($form) {

        jQuery.validator.addMethod("greaterThan", function (value, element, params) {

            if (!/Invalid|NaN/.test(new Date(value))) {
                return new Date(value) > new Date($(params).val());
            }

            return isNaN(value) && isNaN($(params).val()) || Number(value) > Number($(params).val());
        }, 'Must be greater than {0}.');

        $form.validate({
            ignore: [],
            rules: {
                //Departure: { greaterThan: "#postModel_EnquiryData_Arrival" }
            },
            messages: {
                arrival: {
                    required: $('input[name="arrival"]').data("required")
                },
                departure: {
                    required: $('input[name="departure"]').data("required"),
                    greaterThan: $('input[name="departure"]').data("greaterThan")
                },
                accotypeIds: $('input[name="accotypeIds"]').data("required"),
                title: $('input[name="Title"]').data("required"),
                firstname: $('input[name="firstname"]').data("required"),
                lastname: $('input[name="lastname"]').data("required"),
                privacy: $('input[name="privacy"]').data("required"),
                adults: $('input[name="adults"]').data("required"),
                areaId: $('select[name="areaId"]').data("required"),
                //AmenityIds: $('select[name="AreaId"]').data("required"),
                message: $('textarea[name="message"]'),
                email: {
                    required: $('input[name="email"]').data("required"),
                    email: $('input[name="email"]').data("email")
                }
            },
            highlight: function (element, errorClass) {
                if ($(element).hasClass("js-input")) {
                    $(element).parents(".js-input-error").addClass("error");
                }
            },
            unhighlight: function (element, errorClass) {
                if ($(element).hasClass("js-input")) {
                    $(element).parents(".js-input-error").removeClass("error");
                }
            }
        });
    }


    function initChildrenages($form) {
        $('#children').on("change", function () {
            var childrenages = $('#childrenages');
            var count = $(this).val();

            if (count > 0) {
                $('#childrenages-cont').show();
            } else {
                $('#childrenages-cont').hide();
            }

            var actCount = childrenages.find("input[type=number]").size();
            if (count > actCount) {
                for (var i = 0; i < (count - actCount); i++) {
                    $('<input type="number" data-serializearray id="childrenages' + i + '" style="width:40px;margin-right:8px;" name="ChildrenAges" value="" min="1" max="17" />').appendTo(childrenages);
                }
            } else {
                for (var j = 0; j < actCount - count; j++) {
                    childrenages.find("input[type=number]:last-child").remove();
                }
            }
        });
    }

    // ============================

    // global overwritable but called after submit
    gardaseeContext.LoadEnquiryThanks = function (companyId, arrival, departure, filter) {
        $.ajax({
            cache: false,
            url: '/api/enquiry/enquirythanks',
            type: "POST",
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                language: gardaseeContext.language,
                companyId: companyId || 0,
                arrival: arrival,
                departure: departure,
                filter: filter || null
            }),
            //traditional: true,
            success: function (callback) {
                $('#enquiryform').hide(); // <- this hides the loader
                $('#enquiryThanksContainer').html(callback.html);
                $('#enquiryThanksContainer').show();

                $('a[data-gaq]').unbind('click', GaTrackEvent);
                $('a[data-gaq]').bind('click', GaTrackEvent);
            }
        });
    };

    // ============================


    // public
    var request = null;
    window.UpdateCompanyCount = function(amenityIds, boardingIds, callbackAmenityCount) {

        currentBoardingIds = boardingIds;
        currentAmenityIds = amenityIds;
        var filter = getEnquiryFilter();

        if (request !== null) {
            request.abort();
        }

        request = $.ajax({
            cache: false,
            type: "Post",
            url: "/api/enquiry/enquirycount",
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            traditional: true,
            data: JSON.stringify(filter)
        }).done(function(data) {
            var enquiryCount = data.count
            var companyIds = data.count.companyIds

            //doing this for general enquiry to insert the companyIds in the input hidden field
            document.querySelector("#js-companyIds").value = companyIds

            if (typeof callbackAmenityCount == "function") {
                callbackAmenityCount(enquiryCount);
            }

            if (enquiryCount.Count == 0) {
                $("#NoEntryError").parent().show();
                $("#companycount").parent().parent().css("color", "red");
                $('#submitbutton').attr("disabled", "disabled");
                $('#noCompaniesSelected').show();
            } else {
                $("#NoEntryError").parent().hide();
                $("#companycount").parent().parent().css("color", "");
                $('#submitbutton').removeAttrs("disabled");
                $('#noCompaniesSelected').hide();
            }
            request = null;
        });
    };


    // privates

    function getEnquiryFilter() {
        var areaId = $("#AreaId").val();
        var themeId = $("#ThemeId").val();

        var accotypeIds = [];
        $.each($("[name='AccotypeIds']:checked"), function () {
            accotypeIds.push($(this).val());
        });

        if (
            !areaId &&
            !themeId &&
            !accotypeIds.length &&
            !currentAmenityIds &&
            !currentBoardingIds
        ) {
            return null;
        }

        var filter = {
            AreaIds: areaId ? [+areaId] : null,
            ThemeIds: themeId ? [+themeId] : null,
            Accotypes: accotypeIds[0] ? [{
                Id: +accotypeIds[0],
                RatingFrom: 0,
                RatingTo: 5
            }] : null,
            BoardingIds: (currentBoardingIds || []).flatMap(_ => _.split(',')),
            AmenityIds: (currentAmenityIds || []).flatMap(_ => _.split(','))
        };
        return filter;
    }


    function formatErrors(errors) {
        if (errors == null || errors == "") {
            return "";
        }

        var html = "<ul>";
        for (var c in errors) {
            //if (errors.hasOwnProperty(c)) {
            html += "<li>" + errors[c] + "</li>";
            //}
        }
        html += "</ul>";
        return html;
    }

    function trackGtm(data, callback) {
        // data:: { "portalId": "7", "language": "de", "referer": "", "wishedoffers": "1", "ip": "0.0.0.0", "companyIds": [ "72399" ], "enquirytype": "2", "tag": "", "regionId": "-1", "arrival": "13.06.2024", "departure": "14.06.2024", "adults": "1", "boardingIds": [], "children": "0", "email": "user@example.com", "title": "Herr", "firstname": "inetcons", "lastname": "inetcons", "Phone": "", "message": "test", "privacy": true, "amenityIds": [], "rooms": [ { "adults": "1", "children": "0" } ], "filter": { "boardingids": [] }, "newsletter": false }
        // callback:: { "success": true, "errors": null, "enquiryType": 2, "enquiryStageId": 2049385, "companiesCount": 1, "debugJson": "" }
        window.siteEventEnquiry({
                enquiryType: callback.enquiryType,
                language: data.language
            },
            {
                enquiryStageId: callback.enquiryStageId,
                companies: data.companyIds
            });
    }

})(window.gardaseeContext);


// serializeObject
(function () {
    "use strict";

    $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        var value;
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || "");
            } else {
                value = this.value || "";
                if ($('[name="' + this.name + '"]').data("serializearray") != undefined) {
                    value = [value];
                }
                o[this.name] = value;
            }
        });
        return o;
    };

})();
